import { Children, ReactElement, ReactNode, cloneElement } from 'react';
import { isElement, isFragment } from 'react-is';

import countNonEmptyChildren from './countNonEmptyChildren';

type MappingFunction = (
    child: ReactElement,
    index: number,
    total: number
) => ReactNode;

const mapElementsRecursive = (
    children: Array<ReactNode>,
    map: MappingFunction,
    index = -1,
    total = -1
): ReactNode | Array<ReactNode> => {
    if (total === -1) {
        total = countNonEmptyChildren(children);
    }

    return children.map((child) => {
        if (!child) {
            return;
        }

        if (isFragment(child)) {
            return cloneElement(child, {
                ...child.props,
                children: mapElementsRecursive(
                    Children.toArray(child.props.children),
                    map,
                    index,
                    total
                ),
            });
        }

        if (!isElement(child)) {
            return child;
        }

        index++;

        return map(child, index, total);
    });
};

export default mapElementsRecursive;
